import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'

import { createServer } from '@/api/MockedServer'

if (import.meta.env.DEV && import.meta.env.VITE_MIRAGE_ENABLED === 'true') {
    createServer({
        environment: 'development',
    })
}

createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <App />
    </StrictMode>,
)
